import React, { PureComponent } from 'react';
import SelectInput from './SelectInput';
import OpenInput from './OpenInput';
import SelectValueUtil, {
  SupportedArrayTypes,
  SupportedTypes,
  SupportedItemType,
} from './SelectValueUtil';

export interface SelectFieldOwnProps {
  itemType: SupportedItemType;
  value: SupportedTypes | SupportedArrayTypes;
  onChange: (value: SupportedTypes | SupportedArrayTypes) => void;
  options: SupportedArrayTypes;
  isOpenChoice: boolean;
  isMultiSelect: boolean;
  label?: string;
  disabled?: boolean;
  error?: string;
  linkId?: string;
  className?: string;
}

interface SelectFieldState {
  isOpenChoiceFocused: boolean;
}

type SelectFieldProps = SelectFieldOwnProps;

class SelectField extends PureComponent<SelectFieldProps, SelectFieldState> {
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  state = { isOpenChoiceFocused: null as boolean };

  getValueUtil = (): SelectValueUtil =>
    new SelectValueUtil(
      {
        isMultiSelect: this.props.isMultiSelect,
        isOpenChoice: this.props.isOpenChoice,
        itemType: this.props.itemType,
      },
      this.props.options,
      this.props.value,
    );

  handleOpenChoiceCancel = () => {
    this.setState({ isOpenChoiceFocused: false });
  };

  handleAddOpenChoice = () => {
    // this should be prevented by config, but just to be safe
    if (!['coding', 'time', 'date'].includes(this.props.itemType)) {
      this.setState({ isOpenChoiceFocused: true });
    }
  };

  handleSubmitOpenChoice = (value: string | number) => {
    this.setState({ isOpenChoiceFocused: false });

    const newValue = this.getValueUtil().processAddOpenChoice(value);
    this.props.onChange(newValue);
  };

  render() {
    const {
      itemType,
      options,
      isOpenChoice,
      isMultiSelect,
      label,
      disabled,
      error,
      linkId,
      className,
    } = this.props;

    if (
      this.state.isOpenChoiceFocused &&
      itemType !== 'coding' &&
      itemType !== 'time' &&
      itemType !== 'date'
    ) {
      return (
        <OpenInput
          className={className}
          itemType={itemType}
          onCancel={this.handleOpenChoiceCancel}
          onComplete={this.handleSubmitOpenChoice}
          linkId={linkId}
        />
      );
    } else {
      return (
        <SelectInput
          className={className}
          itemType={itemType}
          onChange={this.props.onChange}
          value={this.props.value}
          options={options}
          isOpenChoice={isOpenChoice}
          isMultiSelect={isMultiSelect}
          onAddOpenChoice={this.handleAddOpenChoice}
          label={label}
          disabled={disabled}
          error={error}
          linkId={linkId}
        />
      );
    }
  }
}

export default SelectField;
